'use client';

import { useEffect } from 'react';
import { sendWebEvent, type SendWebEventInput } from '@/lib/analytics/web-event-client';

/** Отправить одно событие при показе блока (просмотр каталога, материала, гейта). */
export function TrackWebEvent(props: SendWebEventInput) {
  const { name, subject, surface, cabinet } = props;
  useEffect(() => {
    sendWebEvent({ name, subject, surface, cabinet });
  }, [name, subject, surface, cabinet]);
  return null;
}
